import { isTokenExpired, isValidTokenFormat } from "../../apis/configs/apiClient";

const getInitialAuthState = () => {
  const token = localStorage.getItem("token");

  let persistedState = null;
  try {
    const persistedData = localStorage.getItem('auth_state');
    if (persistedData) {
      persistedState = JSON.parse(persistedData);
      
      const maxAge = 24 * 60 * 60 * 1000; 
      if (persistedState.timestamp && (Date.now() - persistedState.timestamp) > maxAge) {
        localStorage.removeItem('auth_state');
        persistedState = null;
      }
    }
  } catch (error) {
    console.warn('initialState: Failed to parse persisted auth state:', error);
    localStorage.removeItem('auth_state');
  }

  // Check token validity
  const isTokenValid = token && isValidTokenFormat(token) && !isTokenExpired(token);
  
  // If token is expired or invalid, clear everything
  if (token && !isTokenValid) {
    localStorage.removeItem('token');
    localStorage.removeItem('auth_state');
    persistedState = null;
  }

  const defaultMe = {
    id: null,
    name: null,
    email: null,
    numeroInscricao: null,
    cpf: null,
    cellphone: null, 
    role: null,
    nameSocial: null,
    fotos: [],
    image: null,
    empresa: null
  };


  const hasValidPersistedState = persistedState?.logged && persistedState?.me?.id;
  const isLoggedIn = isTokenValid && hasValidPersistedState;
  const needsValidation = isTokenValid && !hasValidPersistedState;

  const initialState = {
    me: persistedState?.me || defaultMe,
    loading: needsValidation,
    logged: isLoggedIn,
    status: persistedState?.status || "1111",
    errorMessage: "",
    errors: [],
    token: isTokenValid ? token : null,
    blank: false,
    shouldRedirectToLogin: false
  };



  return initialState;
};

export const initialState = getInitialAuthState();
